// extracted by mini-css-extract-plugin
export var alt = "Footer-module--alt--554df";
export var brandLogos = "Footer-module--brandLogos--27160";
export var contentCol = "Footer-module--contentCol--554cd";
export var copyRight = "Footer-module--copyRight--a42c3";
export var ctaCol = "Footer-module--ctaCol--f0af3";
export var desktopOnly = "Footer-module--desktopOnly--0cb6a";
export var footer = "Footer-module--footer--fc431";
export var footerBrandContainer = "Footer-module--footerBrandContainer--78690";
export var footerContent = "Footer-module--footerContent--364fb";
export var footerInner = "Footer-module--footer-inner--ef37c";
export var footerLinks = "Footer-module--footer-links--33fa3";
export var footerWrapper = "Footer-module--footerWrapper--e44da";
export var goNativeFooterBrand = "Footer-module--goNativeFooterBrand--b2343";
export var iconCol = "Footer-module--iconCol--80825";
export var logo = "Footer-module--logo--e194d";
export var logoCol = "Footer-module--logoCol--7e0af";
export var main = "Footer-module--main--b01db";
export var menu = "Footer-module--menu--79e54";
export var mobileOnly = "Footer-module--mobileOnly--c1412";
export var show = "Footer-module--show--5ab32";
export var textLeft = "Footer-module--textLeft--d35cc";
export var visuallyHidden = "Footer-module--visuallyHidden--b6006";